module.exports = __webpack_public_path__ + "img/imgNo.915f3f61.svg";